<template>
  <el-dialog
    custom-class="custom-dialog"
    :visible="true"
    width="750px"
    :lock-scroll="false"
    :append-to-body="true"
    @close="handleCancel"
    :fullscreen="fullscreen"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
  >
    <template #title>
      <span>{{ form.id === 0 ? '添加用户' : '编辑用户' }}</span>
      <i
        class="full-screen"
        :class="[fullscreen ? 'el-icon-crop' : 'el-icon-full-screen']"
        @click="handleFull"
      ></i>
    </template>
    <el-form :model="form" ref="form" label-width="80px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="账号:" required>
            <el-input v-model="form.account" :readonly="form.id > 0">
              <el-select v-model="form.isEnable" slot="append" placeholder="状态" style="width:75px;">
                <el-option :value="true" label="启用"></el-option>
                <el-option :value="false" label="停用"></el-option>
              </el-select>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="密码:" :required="form.id === 0">
            <el-input
              type="password"
              show-password
              v-model.trim="form.password"
              :placeholder="
                                form.id > 0 ? '不修改请留空' : '大小写英文/数字/特殊字符,8-16位'
                            "
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="父节点:">
            <el-select v-model="parentsValue" placeholder="请选择">
              <el-option v-if="parentsValue === 0" label="无" :value="0"></el-option>
              <el-option v-for="item in parents" :key="item.id" :label="item.name" :value="item.id">
                <div :style="{ 'text-indent': item.depth + 'em' }">{{ item.name }}</div>
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="姓名:" required>
            <el-input v-model="form.name"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="手机号:">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮箱:">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="头像:">
            <east-img :src="form.image" :width="50" :height="50" @read="readImage"></east-img>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="签名:">
            <east-img
              :src="form.eSign"
              accept="image/png"
              :width="160"
              :height="50"
              @read="readESign"
            ></east-img>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="API授权:" required class="auth-box">
        <div v-for="(item, index) in this.authsData" :key="index">
          <el-checkbox
            :indeterminate="item.indeterminate"
            v-model="item.checkAll"
            @change="handleCheckAllChange($event, item)"
            :disabled="form.account === $store.getters.account"
          >
            <span class="group">{{ item.group }}</span>
          </el-checkbox>
          <p>
            <el-checkbox-group
              v-model="item.values"
              @change="handleCheckedAuthChange($event, item)"
            >
              <el-checkbox
                v-for="(auth, index) in item.list"
                :key="index"
                :label="auth.value"
                :disabled="auth.disabled"
              >{{ auth.name }}</el-checkbox>
            </el-checkbox-group>
          </p>
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button type="primary" @click="submitForm">提交</el-button>
      <el-button @click="handleCancel">取消</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { getParentAuths, getAuthsData } from "../../../../api/main/api-auths";
import { addUser, editUser } from "../../../../api/main/api-user";
import EastImg from "../../../../components/east-img";
export default {
  data() {
    return {
      parents: [],
      parentsValue: null,
      authsData: [],
      form: this.userData,
      fullscreen: false,
      defaultImage:
        "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAAFEmlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDIgNzkuMTYwOTI0LCAyMDE3LzA3LzEzLTAxOjA2OjM5ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIgeG1sbnM6cGhvdG9zaG9wPSJodHRwOi8vbnMuYWRvYmUuY29tL3Bob3Rvc2hvcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1wOkNyZWF0b3JUb29sPSJBZG9iZSBQaG90b3Nob3AgQ0MgKFdpbmRvd3MpIiB4bXA6Q3JlYXRlRGF0ZT0iMjAxOS0xMi0xMFQxNjoyMzo0OSswODowMCIgeG1wOk1vZGlmeURhdGU9IjIwMTktMTItMTBUMTg6Mjg6MTgrMDg6MDAiIHhtcDpNZXRhZGF0YURhdGU9IjIwMTktMTItMTBUMTg6Mjg6MTgrMDg6MDAiIGRjOmZvcm1hdD0iaW1hZ2UvcG5nIiBwaG90b3Nob3A6Q29sb3JNb2RlPSIzIiBwaG90b3Nob3A6SUNDUHJvZmlsZT0ic1JHQiBJRUM2MTk2Ni0yLjEiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6N2NiZDRjODItMThjMS0zYTQzLWE0YmEtNTU2Zjk5NmFlNGMwIiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjdjYmQ0YzgyLTE4YzEtM2E0My1hNGJhLTU1NmY5OTZhZTRjMCIgeG1wTU06T3JpZ2luYWxEb2N1bWVudElEPSJ4bXAuZGlkOjdjYmQ0YzgyLTE4YzEtM2E0My1hNGJhLTU1NmY5OTZhZTRjMCI+IDx4bXBNTTpIaXN0b3J5PiA8cmRmOlNlcT4gPHJkZjpsaSBzdEV2dDphY3Rpb249ImNyZWF0ZWQiIHN0RXZ0Omluc3RhbmNlSUQ9InhtcC5paWQ6N2NiZDRjODItMThjMS0zYTQzLWE0YmEtNTU2Zjk5NmFlNGMwIiBzdEV2dDp3aGVuPSIyMDE5LTEyLTEwVDE2OjIzOjQ5KzA4OjAwIiBzdEV2dDpzb2Z0d2FyZUFnZW50PSJBZG9iZSBQaG90b3Nob3AgQ0MgKFdpbmRvd3MpIi8+IDwvcmRmOlNlcT4gPC94bXBNTTpIaXN0b3J5PiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PvsCsNAAAAMXSURBVGiB7Vpdd5swDL2W7UApgb70//+77aklJQHzZXkPPbCuPQkEeyHr2X21LXQtJEuyhXPuB4AU/zZOwjnnttYiBAjAcWslAuBIW2sQCv+J3Bv+E7k3qNACh2FA13Xo+x7MjDG6K6UQxzF2u13oT77LDyWImVGWJYwxEwEhxDTunMPxeESWZUjT9I+xEBDOuRLA3kfIMAx4eXlB13VQSp1V0jkH5xyUUoiiCFmWhSJ09LaIcw5FUaDve2itL84VQkAIgWEY0LYt2rbF8/NzEDLezl7XNdq2hVLL94SIoLVG27Yoy9JXhXeZvgKaplm9o0op1HUNa62vGn5EmBnW2tVEhBBgZnRd56MGAE8i1lovIiNCJODf5kC8CyKbRy0iApHfXowh2RdeWkgpQURg5lXrnXMgoqtC9zl4/1pSytVrmRlKqfsgEkXRputHeBPxOQOEEOj7fvvw2/c9jDGrHV4IAWPM9gdiiKhFRPcRtbTWGIZh1XprLZRSs1nzEnj7SJZliKLo6hDMzNBa4+npaXuLAIDWGnmeX+2wzIz9fh/EGkCgFEVrDSnlYqs45yClDFq/ByFCRIjjeDERay2iKApyEE46hBKUpukiq4xpyX7v1Sb4gmBElFLI83x2XmjfGBE0jY+iCER01vHHFlGotOQjghL52JCbmxcaNy2sQjflPiI4kTmL/K0LsqBEqqr60ir9DCEEqqoK+VkAgYgwMw6HA6qqmi20iAhN06AoiiD9rBFeJxIzo65r1HU99X2XQEo5dSgfHx+RJIlXpQmsbGJ3XQdjDJqmQd/3q9N5Zp7K3TiO8fDwsDY0H68iYoyZdpKZg9QjwG9CRITdbockSZAkyTUilhHpug5lWU593lDF0Gc456azaLx2WGiheSJ1XaMoCgB+HZNrMQaCPM+RprMPMy7fsxtj8Pr6CiHETUkA75smhEBRFIvC9Vki1locDofpV9oCRAQpJd7e3mbL6bMaVlUFa+3NLfEZRARrLU6n08V5ZwN/0zST890D2ra9OH6WyJLa4paYi5Lf5pmTAvAT3+Dh2S/DWo3Us506FgAAAABJRU5ErkJggg==",
      defaultESign:
        "data:image/png;base64,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",
      imageFile: null,
      esignFile: null
    };
  },
  props: {
    userData: {
      type: Object
    }
  },
  watch: {
    parentsValue(newVal, oldVal) {
      this.form.pid = newVal;
      this.fetchAuths();
    }
  },
  components: {
    "east-img": EastImg
  },
  created() {
    // 仅首次调用
    if (this.form.image === "") {
      this.form.image = this.defaultImage;
    }
    if (this.form.eSign === "") {
      this.form.eSign = this.defaultESign;
    }
    if (this.form.id > 0) {
      this.form.password = "";
    }
    this.fetchParents();
    this.fetchAuths();
  },
  methods: {
    fetchParents() {
      getParentAuths(this.form.id).then(res => {
        if (res.code === 0) {
          this.parents = res.data;
          this.parentsValue = this.form.pid;
        }
      });
    },
    fetchAuths() {
      getAuthsData(this.form.pid, this.form.id).then(res => {
        if (res.code === 0) {
          this.authsData = [];
          res.data.forEach(item => {
            var checkedCount = item.authList.filter(a => a.checked).length;
            this.authsData.push({
              group: item.group,
              list: item.authList.map(au => {
                return {
                  name: au.name.replace(item.group + "/", ""),
                  value: au.value,
                  checked: au.checked,
                  disabled: au.disabled
                };
              }),
              values: item.authList
                .filter(it => it.checked)
                .map(au => au.value),
              checkAll: checkedCount === item.authList.length,
              indeterminate:
                checkedCount > 0 && checkedCount < item.authList.length
            });
          });
        }
      });
    },
    handleFull() {
      this.fullscreen = !this.fullscreen;
    },
    handleCancel() {
      this.$emit("hide");
    },
    handleCheckAllChange(val, item) {
      item.values = val ? item.list.map(it => it.value) : [];
      item.indeterminate = false;
    },
    handleCheckedAuthChange(val, item) {
      let checkedCount = item.values.length;
      item.checkAll = checkedCount === item.list.length;
      item.indeterminate = checkedCount > 0 && checkedCount < item.list.length;
    },
    readImage(f, d) {
      this.imageFile = f;
    },
    readESign(f, d) {
      this.esignFile = f;
    },
    submitForm() {
      let vArry = [];
      this.authsData
        .map(it => it.values)
        .forEach(p => {
          vArry = vArry.concat(p);
        });
      this.form.value = vArry.join(",");
      if (this.form.account.trim() === "") {
        this.$message.error("请输入账号");
      } else if (this.form.password.trim() === "" && this.form.id === 0) {
        this.$message.error("请输入密码");
      } else if (this.form.name.trim() === "") {
        this.$message.error("请输入姓名");
      } else if (this.form.value.trim() === "") {
        this.$message.error("请至少选择一个授权");
      } else {
        let formData = new FormData();
        Object.keys(this.form).forEach(key => {
          if (key === "image") {
            formData.append(key, this.imageFile);
          } else if (key === "eSign") {
            formData.append(key, this.esignFile);
          } else if (this.form[key] !== null && this.form[key] !== undefined) {
            formData.append(key, this.form[key]);
          }
        });
        if (this.form.id === 0) {
          // 添加用户
          addUser(formData).then(res => {
            if (res.code === 0) {
              // 刷新授权列表
              this.$emit("refresh");
              this.$confirm("添加用户成功,是否继续添加?", "提示", {
                confirmButtonText: "添加",
                cancelButtonText: "取消",
                type: "success",
                lockScroll: false
              })
                .then(() => {
                  this.form.account = "";
                  this.form.password = "";
                  this.form.name = "";
                  this.form.phone = "";
                  this.form.email = "";
                  this.form.image = this.defaultImage;
                  this.form.eSign = this.defaultESign;
                  this.fetchParents();
                  this.fetchAuths();
                })
                .catch(() => {
                  this.handleCancel();
                });
            } else {
              this.$message.error(res.msg);
            }
          });
        } else {
          // 编辑用户
          editUser(formData).then(res => {
            if (res.code === 0) {
              // 刷新授权列表
              this.$emit("refresh");
              this.$confirm("编辑用户成功,是否调整?", "提示", {
                confirmButtonText: "调整",
                cancelButtonText: "取消",
                type: "success",
                lockScroll: false
              }).catch(() => {
                this.handleCancel();
              });
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      }
    }
  }
};
</script>
<style lang="less">
.custom-dialog {
  .el-dialog__header {
    padding: 20px 30px 5px;
  }
  .el-dialog__body {
    padding: 10px 30px 5px 30px;
  }
  .el-dialog__footer {
    padding: 20px 30px;
  }
  .el-form-item {
    margin-bottom: 15px;
    .p45 {
      width: 45%;
      display: inline-block;
    }
  }
  .auth-box {
    span.group {
      font-weight: bold;
    }
    p {
      padding: 0;
      margin: 0;
    }
  }
}
.full-screen {
  position: absolute;
  top: 20px;
  right: 45px;
  cursor: pointer;
  font-size: 14px;
  color: #555555;
  &:hover {
    color: #1c99ff;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/main/security/auth/user.vue